var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.initSplash),expression:"initSplash"}],staticStyle:{"opacity":"0.85"},style:({backgroundColor:_vm.background}),attrs:{"id":"splash"}},[_c('div',{staticClass:"content-box"},[(_vm.logo)?_c('v-img',{staticClass:"content",style:(_vm._f("mq")(_vm.$mq,{
          mobile:'margin:0 25%;',
          tablet:'margin:0 37.5%;',
          desktop:'margin:0 42.5%;'
        })),attrs:{"src":("./" + _vm.logo),"width":_vm._f("mq")(_vm.$mq,{
          mobile:'50%',
          tablet:'25%',
          desktop:'15%'
        })}}):_vm._e(),_c('p',{staticClass:"content"},[_c('v-icon',{style:(_vm._f("mq")(_vm.$mq,{
            mobile:'margin-top: 20%;',
            tablet:'margin-top: 15%;',
            desktop:'margin-top: 5%;'
          }))},[_vm._v("\n          mdi-loading mdi-spin mdi-48px\n        ")])],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }